import { api } from "../api/client";

/** Load the preview JPEG, and the original PDF only when needed. */
export async function loadReceiptMedia(
  receiptId: number,
  isPdf: boolean,
): Promise<{ previewUrl: string; fileUrl: string; revoke: () => void }> {
  const previewBlob = await api.download(`/receipts/${receiptId}/preview`);
  const previewUrl = URL.createObjectURL(previewBlob);
  if (!isPdf) {
    return {
      previewUrl,
      fileUrl: previewUrl,
      revoke: () => URL.revokeObjectURL(previewUrl),
    };
  }
  const fileBlob = await api.download(`/receipts/${receiptId}/file`);
  const typed = fileBlob.type.includes("pdf")
    ? fileBlob
    : new Blob([fileBlob], { type: "application/pdf" });
  const fileUrl = URL.createObjectURL(typed);
  return {
    previewUrl,
    fileUrl,
    revoke: () => {
      URL.revokeObjectURL(previewUrl);
      URL.revokeObjectURL(fileUrl);
    },
  };
}
